<template>
  <div
    id="statusContents"
    :class="['desktop', 'laptop'].includes($mq) ? 'deskMode' : 'mobileMode'"
  >
    <div
      v-for="(stake, index) in getStatus"
      :key="`Status_${index}`"
      class="status"
    >
      <el-row type="flex">
        <el-col
          :span="responsiveCol.two"
        >
          <div
            :class="{
              mobileRole: ['mobile', 'tablet'].includes($mq),
              role: ['desktop', 'laptop'].includes($mq),
              left: $mq === 'tablet'
            }"
          >
            {{ stake.role }}
          </div>
        </el-col>
        <el-col :span="responsiveCol.one">
          <div
            class="statusNumber"
            :class="$mq === 'mobile' ? 'right' : ''"
          >
            {{ stake.response }} / {{ stake.amount }}
          </div>
        </el-col>
        <el-col :span="responsiveCol.three">
          <el-progress
            :percentage="stake.percent"
            :color="pulseColor"
            :show-text="false"
          />
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    pulseEach: {
      type: Object,
      default: null,
    },

    pulseName: {
      type: String,
      default: null,
    },

    pulseNumber: {
      type: Number,
      default: 1,
    },
  },

  computed: {
    getStatus() {
      const status = {};

      if (this.pulseEach) {
        // Pulse for leader
        if (this.pulseEach.self) {
          const getSelf = this.pulseEach.self.split('/');
          // if (getSelf[1] * 1 > 0) {
          status.self = {
            role: 'Self',
            response: getSelf[0] * 1,
            amount: getSelf[1] * 1,
            percent: ((getSelf[0] * 1) / (getSelf[1] * 1))
              ? ((getSelf[0] * 1) / (getSelf[1] * 1)) * 100 : 0,
          };
          // }
        }

        if (this.pulseEach.line_manager_status) {
          const getLine = this.pulseEach.line_manager_status.split('/');
          // if (getLine[1] * 1 > 0) {
          status.line_manager = {
            role: 'Manager(s)',
            response: getLine[0] * 1,
            amount: getLine[1] * 1,
            percent: ((getLine[0] * 1) / (getLine[1] * 1))
              ? ((getLine[0] * 1) / (getLine[1] * 1)) * 100 : 0,
          };
          // }
        }

        if (this.pulseEach.sh_status) {
          const getSh = this.pulseEach.sh_status.split('/');
          // if (getSh[1] * 1 > 0) {
          status.stakeholder = {
            role: 'Coworkers',
            response: getSh[0] * 1,
            amount: getSh[1] * 1,
            percent: ((getSh[0] * 1) / (getSh[1] * 1))
              ? ((getSh[0] * 1) / (getSh[1] * 1)) * 100 : 0,
          };
          // }
        }
      }

      return status;
    },

    responsiveCol() {
      const col = {};

      if (this.$mq === 'mobile') {
        col.one = 12;
        col.two = 12;
        col.three = 24;
      } else if (this.$mq === 'tablet') {
        col.one = 5;
        col.two = 9;
        col.three = 10;
      } else {
        col.one = 24;
        col.two = 24;
        col.three = 24;
      }

      return col;
    },

    pulseColor() {
      switch (this.pulseName) {
        case 'pulse1':
          return '#f3c065';
        case 'pulse2':
          return '#3aaace';
        case 'pulse3':
          return '#b79eff';
        default:
          return null;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
  #statusContents {
    display: flex;
    width: 100%;
    min-height: calc(100% - 33px);
    flex-direction: column;

    .status {
      width: 100%;
      padding: 20px 0;

      .el-row {
        flex-wrap: wrap;
        align-items: center;
      }

      .statusNumber {
        font-size: 16px;
        font-weight: bold;
        padding-bottom: 10px;
      }

      .mobileRole {
        font-size: 16px;
        text-transform: capitalize;

        &.right {
          text-align: right;
        }
      }

      .role {
        font-size: 16px;
        padding-bottom: 5px;
      }

      .responded {
        font-size: 12px;
      }
    }

    &.mobileMode {
      padding-bottom: 10px;
      border-bottom: 1px solid rgba(255, 255, 255, 0.5);
      margin-bottom: 15px;
      box-sizing: border-box;

      .status {
        padding: 5px 0;
      }

      .statusNumber {
        font-size: 16px;
        padding: 0;

        &.right {
          text-align: right;
        }
      }
    }
  }
</style>

<style lang="scss">
  #statusContents {
    .status {
      .el-progress {
        padding-bottom: 22px;
      }
    }

    &.mobileMode {
      .el-progress {
        padding: 10px 0;

        .el-progress-bar {
          .el-progress-bar__outer {
            background-color: white;
          }
        }
      }
    }
  }
</style>
